module.exports = __webpack_public_path__ + "static/media/navigation.df9242f4.png";